import { useCallback, useEffect, useRef, useState } from 'react';
import { useRecaptchaConfig } from '../contexts/RecaptchaContext';

let scriptPromise;
function loadScript(siteKey) {
  if (window.grecaptcha) return Promise.resolve(window.grecaptcha);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${encodeURIComponent(siteKey)}`;
      script.async = true; script.defer = true;
      script.onload = () => window.grecaptcha.ready(() => resolve(window.grecaptcha));
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

export function useRecaptcha() {
  const { config, loading, error, retry } = useRecaptchaConfig();
  const [ready, setReady] = useState(false);
  const widgetId = useRef(null);
  useEffect(() => {
    if (config && config.v3SiteKey) loadScript(config.v3SiteKey).then(() => setReady(true)).catch(() => setReady(false));
  }, [config]);
  const executeV3 = useCallback(async () => {
    if (!config || !config.v3SiteKey) throw new Error('Captcha configuration is unavailable');
    const grecaptcha = await loadScript(config.v3SiteKey);
    return grecaptcha.execute(config.v3SiteKey, { action: config.action });
  }, [config]);
  const renderV2Widget = useCallback(async (containerId, onToken) => {
    if (!config || !config.v2SiteKey) throw new Error('Captcha configuration is unavailable');
    const grecaptcha = await loadScript(config.v3SiteKey);
    const container = document.getElementById(containerId);
    if (!container) throw new Error('Captcha container is unavailable');
    if (widgetId.current !== null) grecaptcha.reset(widgetId.current);
    else widgetId.current = grecaptcha.render(container, { sitekey: config.v2SiteKey, callback: onToken });
    return widgetId.current;
  }, [config]);
  const resetV2Widget = useCallback(() => { if (window.grecaptcha && widgetId.current !== null) window.grecaptcha.reset(widgetId.current); }, []);
  return { config, loading, error, retry, ready, executeV3, renderV2Widget, resetV2Widget };
}
